/**
 * Compares two objects and returns an object containing the changed keys and their new values.
 *
 * @param original - The original object.
 * @param modified - The modified object to compare.
 * @returns An object containing only the changed keys and their updated values.
 */
export function getChangedFields<T extends object>(original: T, modified: T): Partial<T> {
    const changes: Partial<T> = {};

    for (const key in modified) {
        if (modified[key] !== original[key]) {
            changes[key] = modified[key];
        }
    }

    return changes;
}